import queryString from 'query-string';

type FetchNewWordPressPostMetadataParams = {
  stationId: string;
  postMetadataId: number;
  includeContent: boolean;
  includeSiteMetadata: boolean;
};

type WordPressPost = {
  postId: string;
  postDate: string;
  created: Date;
  modified: Date;
  content: string | null;
};

type WordPressSite = {
  siteId: string;
  siteUrl: string;
  siteTitle: string;
  siteDescription: string;
};

export type FetchNewWordPressPostMetadataResponse = {
  wordpresPostMetadataId: number;
  stationId: string;
  post: WordPressPost;
  site: WordPressSite | null;
};

export async function fetchWordPressPostMetadata({
  stationId,
  postMetadataId,
  includeContent,
  includeSiteMetadata,
}: FetchNewWordPressPostMetadataParams): Promise<
  FetchNewWordPressPostMetadataResponse
> {
  try {
    const url = queryString.stringifyUrl({
      url: `/api/proxy/v3/wordpress/webStationId:${stationId}/posts/metadata/${postMetadataId}`,
      query: {
        includeContent: includeContent.toString(),
        includeSiteMetadata: includeSiteMetadata.toString(),
      },
    });
    const response = await fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
    });
    if (response.ok) {
      return response.json();
    }
    throw new Error('Unable to fetch WordPress post metadata.');
  } catch (err) {
    throw new Error(err.message);
  }
}
